module.exports = __webpack_public_path__ + "static/media/privacy-policy.ded1fdd9.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/privacy-policy.pdf
// module id = 142
// module chunks = 0